import React from 'react'
import { Button, Table, Message } from 'antd'
import { getStockSummary } from '../../../api/businessCommodity'
import MultiTable from './multiTable'
import { leadoutStockTable } from '../../../util/index'
import '../Merchandise/style.css'

export default class extends React.Component {
  state = {
    mainList: [],
  }

  constructor(props) {
    super(props)
    // this.multiTableRef = React.createRef()
  }

  componentDidMount() {
    this.getSummaryData()
  }

  getSummaryData = async () => {
    const club_id = sessionStorage.getItem('club_id')
    const { data, status, detail } = await getStockSummary(club_id)
    if (status == 1) {
      this.setState({ mainList: data })
    } else {
      Message.error(detail)
    }
  }

  render() {
    const mainColumns = [
      {
        title: 'id',
        dataIndex: ['store', 'id'],
        key: 'id',
      },
      {
        title: '仓库',
        dataIndex: ['store', 'name'],
        key: 'name',
        render: (text, record, index) => {
          return <span style={{ fontWeight: 'bold' }}>{text}</span>
        },
      },
      {
        title: '总数',
        dataIndex: 'totalQuantity',
        key: 'totalQuantity',
      },
      {
        title: '成本合计（元）',
        dataIndex: 'totalUnitCost',
        key: 'totalUnitCost',
        render: (text, record, index) => {
          return text / 100
        },
      },
    ]

    const expandedRowRender = (record, index, indent, expanded) => {
      const batchColumns = [
        {
          title: 'id',
          dataIndex: 'listingId',
          key: 'listingId',
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
        },
        {
          title: '成本（元）',
          dataIndex: 'unitCost',
          key: 'unitCost',
        },
      ]

      return (
        <MultiTable
          batchColumns={batchColumns}
          record={record}
          batchList={record.stockSummaries}
          openMultiTable={this.openMultiTable}
          tableStatus="records"
          ref={this.multiTableRef}
        ></MultiTable>
      )
    }

    return (
      <div>
        <div>
          <Button
            className="mr-20"
            href={
              this.state.mainList
                ? leadoutStockTable(this.state.mainList || [])
                : null
            }
            download={this.state.mainList ? '商品库存报表.csv' : null}
          >
            导出报表
          </Button>
        </div>

        <div>
          <Table
            style={{ marginTop: '30px' }}
            rowClassName="tableRow"
            bordered
            columns={mainColumns}
            expandable={{
              expandedRowRender,
              defaultExpandedRowKeys:
                this.state.mainList && this.state.mainList.length == 1
                  ? this.state.mainList[0].id
                  : null,
              // onExpand: (expanded, record) => {
              //   this.openMultiTable(expanded, record)
              // },
            }}
            dataSource={this.state.mainList}
            size="small"
            rowKey={(record, index) => index}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/stockRecord.js